import { Typography } from "components/parts/Typography/Typography";
import { colors } from "constants/colors";
import styled from "styled-components";

export const StyledForm = styled.form`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const StyledModalHeader = styled.div`
  margin: auto;
`;

export const StyledModalContent = styled.div`
  display: flex;
  justify-content: center;
  margin: auto;
  padding: 2rem 0;
  height: 100%;
  width: 100%;
  gap: 3rem;
`;

export const StyledVerticalArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: 100%;
`;

export const StyledFormRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  span {
    width: 8em;
  }
`;

export const StyledInterviewTypeWrapper = styled.div`
  display: flex;
  column-gap: 1rem;
  div {
    margin: 0px;
  }
`;

export const StyledButtonArea = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 1rem;
`;

export const StyledModalFooter = styled.div`
  display: flex;
  justify-content: end;
  width: 100%;
`;

export const StyledRedTypography = styled(Typography)`
  color: ${colors.error};
`;
